"use strict";

module.exports = function (validation) {
  return {
    validate: function validate(params) {
      try {
        validation(params);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    }
  };
};
//# sourceMappingURL=promisifiedValidator.js.map